(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxViewLinksPanel', {
		bindings: {
			activeView: '<',
			views: '<',
			showDetails: '<',
			itemClickHandler: '<',
			onViewTabChanged: '&',
			viewsFilter: '<',
		},
		controller: MxViewLinksPanel,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-left-side-panel/mx-view-links-panel/mx-view-links-panel.html',
	});

	MxViewLinksPanel.$inject = ['$scope'];

	function MxViewLinksPanel($scope) {
		var vm = this;
		var viewsFilter,
			views = [];

		vm.$onInit = function () {
			vm.filteredViews = vm.views;
		};

		Object.defineProperty(vm, 'views', {
			get: function () {
				return views;
			},
			set: function (newViews) {
				views = newViews;
				searchViews(vm.viewsFilter);
			},
		});

		Object.defineProperty(vm, 'viewsFilter', {
			get: function () {
				return viewsFilter;
			},
			set: function (newFilter) {
				searchViews(newFilter);
				viewsFilter = newFilter;
			},
		});

		var searchViews = $.debounce(500, function (newFilter) {
			$scope.$evalAsync(function () {
				if (newFilter) {
					vm.filteredViews = vm.views.filter(function (view) {
						return view.displayName?.toLowerCase().indexOf(newFilter.toLowerCase()) >= 0;
					});
				} else {
					vm.filteredViews = vm.views;
				}
			});
		});

		return vm;
	}
})();
